import React from 'react';
import { X, CornerDownRight } from 'lucide-react';
import { CtaButton } from './CtaButton';
const rows: {
  without: string;
  cost: string;
}[] = [{
  without: 'Improvisás tus videos sin un método claro',
  cost: 'Horas perdidas grabando contenido que no convierte'
}, {
  without: 'Buscás información gratis y dispersa en redes',
  cost: 'Meses estancada, sin claridad ni resultados'
}, {
  without: 'Editás a prueba y error, sin estructura',
  cost: 'Videos amateurs que las marcas descartan'
}, {
  without: 'No sabés cómo contactar ni presentarte a las marcas',
  cost: 'Cero colaboraciones pagas — tus ingresos en $0'
}, {
  without: 'Sin un portfolio profesional que te respalde',
  cost: 'Las marcas no te toman en serio'
}, {
  without: 'No sabés cuánto cobrar por tu contenido',
  cost: 'Trabajás por monedas o, peor, gratis'
}, {
  without: 'Sin comunidad ni acompañamiento que te sostenga',
  cost: 'Te frustrás y abandonás antes de lograrlo'
}, {
  without: 'Seguís en la misma rutina que no te llena',
  cost: 'Otro año igual: sin libertad ni ingresos extra'
}];
export function CostOfInactionSection() {
  return <section className="px-6 py-8 md:py-10 flex flex-col items-center text-center w-full bg-brand-navy relative overflow-hidden pt-[25px] pb-[25px] mt-[-45px] mb-[-45px]" data-id="element-89">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#D98BAF]/10 via-brand-navy to-brand-navy pointer-events-none" data-id="element-90"></div>

      <div className="max-w-4xl mx-auto w-full relative z-10 flex flex-col items-center" data-id="element-91">
        <h2 className="font-serif font-bold text-3xl md:text-5xl text-white mb-3 leading-tight tracking-tight" data-id="element-92">
          🤔 ¿CUÁNTO CUESTA <span className="text-[#D98BAF]" data-id="element-93">NO TENERLO</span>?
        </h2>
        <p className="text-brand-cream/80 font-sans text-base md:text-lg max-w-2xl mb-12 leading-relaxed" data-id="element-94">
          Cada semana que seguís sin un método probado, también tiene un precio.
          Esto es lo que realmente estás pagando al no tomar acción:
        </p>

        {/* Comparison table */}
        <div className="w-full max-w-3xl rounded-3xl border border-white/10 overflow-hidden bg-white/[0.03] shadow-[0_20px_50px_-12px_rgba(0,0,0,0.5)]" data-id="element-95">
          {/* Header row */}
          <div className="grid grid-cols-2" data-id="element-96">
            <div className="flex items-center justify-center py-5 px-3 border-r border-b border-white/10 bg-white/[0.03]" data-id="element-97">
              <span className="font-sans font-extrabold uppercase tracking-widest text-[13px] md:text-base text-brand-cream" data-id="element-98">
                Sin Fórmula UGC
              </span>
            </div>
            <div className="flex items-center justify-center py-5 px-3 border-b border-white/10 bg-[#D98BAF]/5" data-id="element-99">
              <span className="font-sans font-extrabold uppercase tracking-widest text-[13px] md:text-base text-[#D98BAF]" data-id="element-100">
                Costo real
              </span>
            </div>
          </div>

          {/* Data rows */}
          {rows.map((row, i) => {
          const isLast = i === rows.length - 1;
          const borderB = isLast ? '' : 'border-b';
          return <div key={i} className="grid grid-cols-2" data-id="element-101">
                {/* Situation */}
                <div className={`flex items-start gap-2.5 text-left py-5 px-4 md:px-6 border-r ${borderB} border-white/10`} data-id="element-102">
                  <X className="text-[#D98BAF] shrink-0 mt-0.5" size={18} strokeWidth={3} data-id="element-103" />
                  <span className="font-sans font-semibold text-brand-cream/90 text-[14px] md:text-[16px] leading-snug" data-id="element-104">
                    {row.without}
                  </span>
                </div>

                {/* Cost */}
                <div className={`flex items-start gap-2.5 text-left py-5 px-4 md:px-6 ${borderB} border-white/10 bg-[#D98BAF]/5`} data-id="element-105">
                  <CornerDownRight className="text-[#D98BAF] shrink-0 mt-0.5" size={18} strokeWidth={3} data-id="element-106" />
                  <span className="font-sans font-bold text-[#D98BAF] text-[14px] md:text-[16px] leading-snug" data-id="element-107">
                    {row.cost}
                  </span>
                </div>
              </div>;
        })}
        </div>

        {/* Closing nudge */}
        <p className="text-white font-serif italic text-xl md:text-3xl leading-relaxed max-w-3xl mt-14 mb-8" data-id="element-108">
          La pregunta no es cuánto cuesta el programa...{' '}
          <strong className="not-italic font-black text-transparent bg-clip-text bg-gradient-to-r from-[#D98BAF] to-brand-pinkDark" data-id="element-109">
            es cuánto te cuesta seguir como estás.
          </strong>
        </p>

        <div className="w-full max-w-md md:scale-110" data-id="element-110">
          <CtaButton variant="gold" data-id="element-111">¡SI, QUIERO INSCRIBIRME!</CtaButton>
        </div>
      </div>
    </section>;
}